import React, { useState } from 'react';
import ReorderingStages from './ReorderingStages';
import StagesTable from './StagesTable';
import useLoadStages from './useLoadStages';

interface Props {
  routeId?: string;
}

const RouteStages: React.FC<Props> = ({ routeId }) => {
  const { handleReload, loading, routeStages } = useLoadStages({ routeId });
  const [isOrdering, setIsOrdering] = useState(false);

  if (!routeId) return null;
  if (loading) return null;
  return (
    <>
      {isOrdering ? (
        <ReorderingStages stages={routeStages} setIsOrdering={setIsOrdering} handleReload={handleReload} />
      ) : (
        <StagesTable routeId={routeId} stages={routeStages} setIsOrdering={setIsOrdering} />
      )}
    </>
  );
};

export default RouteStages;
